

            jQuery(function() {
                var $module = jQuery('#m-1576030780626').children('.module');
                $module.gfV3Product();
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576030780626-0').children('.module');
                var effect = $module.attr('data-effect');
                $module.gfV3ProductImage({
                    'effect': effect
                })
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576030780639').children('.module');
                $module.gfV3ProductImageList({
                    onImageClicked: function(imageUrl, imageZoomUrl) {}
                });

                var style = $module.attr('data-style');
                switch(style) {
                    case 'slider':
                        var navspeed = $module.data('navspeed'),
                            navlg = $module.data('navlg'),
                            navmd = $module.data('navmd'),
                            navsm = $module.data('navsm'),
                            navxs = $module.data('navxs'),
                            collg = $module.data('collg'),
                            colmd = $module.data('colmd'),
                            colsm = $module.data('colsm'),
                            colxs = $module.data('colxs'),
                            dotslg = $module.data('dotslg'),
                            dotsmd = $module.data('dotsmd'),
                            dotssm = $module.data('dotssm'),
                            dotsxs = $module.data('dotsxs'),

                            marginlg = parseInt($module.data('mlg')),
                            marginmd = parseInt($module.data('mmd')),
                            marginsm = parseInt($module.data('msm')),
                            marginxs = parseInt($module.data('mxs'));

                        var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
                        if(mode == 'production') {
                            var loop = $module.data('loop');
                        } else {
                            var loop = 0;
                        }
                        $module.find('.gf_product-images-list').owlCarousel({
                            mouseDrag: true,
                            navSpeed: navspeed,
                            autoWidth: !1,
                            loo: loop,
                            responsiveClass:true,
                            responsive:{
                                0:{
                                    items:colxs,
                                    nav: navxs,
                                    dots:dotsxs,
                                    margin: marginxs
                                },
                                768:{
                                    items:colsm,
                                    nav: navsm,
                                    dots:dotssm,
                                    margin: marginsm
                                },
                                992:{
                                    items:colmd,
                                    nav: navmd,
                                    dots:dotsmd,
                                    margin: marginmd
                                },
                                1200:{
                                    items:collg,
                                    nav: navlg,
                                    dots:dotslg,
                                    margin: marginlg
                                }
                            }
                        });
                        break;
                }
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576030780626-1').children('.module');
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576030780626-2').children('.module');
                $module.gfV3ProductPrice();
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576030780628').children('.module');
                var style = $module.attr('data-style');
                var updatePrice = $module.attr('data-updateprice');

                $module.gfV3ProductQuantity({
                    'style': style,
                    'updatePrice': updatePrice
                });
            });
        
    jQuery(function() {
        var $module = jQuery('#m-1576033935839').children('.module');
        $module.gfV3ProductCartButton({ onItemAdded: function() {}});
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1576034627959').children('.module');
        $module.gfV3ProductDesc();
    });
  
            jQuery(function() {
                var $module = jQuery('#m-1576034124465').children('.module');
                var style = $module.attr('data-style');
                var updatePrice = $module.attr('data-updateprice');

                $module.gfV3ProductQuantity({
                    'style': style,
                    'updatePrice': updatePrice
                });
            });
        
    jQuery(function() {
        var $module = jQuery('#m-1576034116860').children('.module');
        $module.gfV3ProductCartButton({ onItemAdded: function() {}});
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1576036224134').children('.module');

        var limit = parseInt($module.attr('data-limit'));
        if($module.find('.gf_row.gf_row_no_tools .gf_column').length > limit) {
            $module.find('.gf_row.gf_row_no_tools .gf_column:last').hide();
        }
    });
  
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child1').children('.module');
                $module.gfV3Product();
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child1-0').children('.module');
                var effect = $module.attr('data-effect');
                $module.gfV3ProductImage({
                    'effect': effect
                })
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child1-1').children('.module');
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child1-2').children('.module');
                $module.gfV3ProductPrice();
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child1-3').children('.module');
                $module.gfV3ProductCartButton({ onItemAdded: function() {}});
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child2').children('.module');
                $module.gfV3Product();
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child2-0').children('.module');
                var effect = $module.attr('data-effect');
                $module.gfV3ProductImage({
                    'effect': effect
                })
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child2-1').children('.module');
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child2-2').children('.module');
                $module.gfV3ProductPrice();
            });
        
            jQuery(function() {
                var $module = jQuery('#m-1576036224134-child2-3').children('.module');
                $module.gfV3ProductCartButton({ onItemAdded: function() {}});
            });
        
        jQuery(function() {
            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            var $module = jQuery('#m-1576071595516').children('.module');
            if (mode == 'dev') {
                jQuery('#m-1576071595516').attr('data-name', '').css('background-image', 'none').css('min-height', '50px').removeAttr('data-image');
                
                var flag = true;
                var $bkLiquid = parent.jQuery('body').find('#gfFrame').contents().find('#module-1576071595516');
                if ($bkLiquid && $bkLiquid.length > 0) {
                    var $settings = $bkLiquid.find('.settings');
                    try {
                        var name = '';
                        var imageUrl = '';
                        settings = JSON.parse($settings.html());
                        for (var i = 0; i < settings.length; i++) {
                            if (settings[i].name == 'name') {
                                name = settings[i].default_value
                            }
                            if (settings[i].name == 'image') {
                                imageUrl = settings[i].default_value
                            }
                        }
                        if (imageUrl != '') {
                            flag = false;
                            jQuery('#m-1576071595516').css('background-image', 'url(' + imageUrl + ')').css('min-height', '100px').attr('data-image', 'true');
                        }
                        if (name != '' && name != 'Custom Code') {
                            flag = false;
                            jQuery('#m-1576071595516').attr('data-name', name);
                        }
                    } catch(error) {
                        console.log(error);
                    }
                }
                if (flag) {
                    jQuery('#m-1576071595516').attr('data-name', 'Right click on the module, then choose Edit Html / Liquid option to start writing your custom code.');
                }
            }
        });
  
var gemFlag=!1;for(var i=0;i<pageLibs.length;i++){if(pageLibs[i].indexOf('gfv3product.js')!==-1){if(jQuery.gfV3Product==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfv3restabs.js')!==-1){if(jQuery.gfV3ResTabs==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfaccordion.js')!==-1){if(jQuery.gfAccordion==undefined){gemFlag=!0;break}}}if(gemFlag){var count=0;for(var i=0;i<pageLibs.length-1;i++){jQuery.getScript(pageLibs[i],function(){count++;if(count==pageLibs.length-1){jQuery.getScript(pageLibs[pageLibs.length-1],function(){})}})}}